module.exports = __webpack_public_path__ + "static/img/data_dec.72cbe15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2dmap/data_dec.png
// module id = cBZv
// module chunks = 2